import CustomizeReportPage from "./CustomizeReportPage";

export default CustomizeReportPage;
